<div class="info-dialog-container">
  <div class="dialog-header">
    <mat-icon [class]="'dialog-icon icon-' + iconColor">{{ icon }}</mat-icon>
    <h2 mat-dialog-title class="dialog-title">{{ title }}</h2>
  </div>
  <div mat-dialog-content class="dialog-content">
    <p>{{ message }}</p>
  </div>
  <div mat-dialog-actions class="dialog-actions">
    <button mat-raised-button color="primary" (click)="onClose()">
      <mat-icon>{{ buttonIcon }}</mat-icon>
      {{ buttonText }}
    </button>
  </div>
</div>
